module.exports = __webpack_public_path__ + "static/media/so.ea80f848.svg";